import {
  FETCH_LIST_ALL_TRASH_PROJECT_TEMPLATE_REQUEST,
  FETCH_LIST_ALL_TRASH_PROJECT_TEMPLATE_SUCCESS,
  FETCH_LIST_ALL_TRASH_PROJECT_TEMPLATE_FALUIRE,
} from './listAllTrashProjectTemplateTypes'

const initialState = {
  loading: false,
  allTrashProjectTemplateList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LIST_ALL_TRASH_PROJECT_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LIST_ALL_TRASH_PROJECT_TEMPLATE_SUCCESS : return {
      ...state,
      allTrashProjectTemplateList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LIST_ALL_TRASH_PROJECT_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      allTrashProjectTemplateList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
